import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

const FLAG_KEY = 'release-scribe-no-speech-warning-startup';

/** SCR-8134: FE-only startup transcription warning, default OFF. */
export const useIsNoSpeechWarningStartupEnabled = (): boolean =>
  useBooleanFlagValue(FLAG_KEY, false);

/** Imperative gate for native upload callbacks outside React. */
export const isNoSpeechWarningStartupEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(FLAG_KEY, false);
